'use client';

import React, { useEffect, useRef, useCallback } from 'react';
import lottie from 'lottie-web';

function LottieAnimation({ animationData }) {
  const container = useRef(null);
  const animation = useRef(null);

  const loadAnimationData = useCallback(() => {
    try {
      animation.current = lottie.loadAnimation({
        container: container.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    } catch (error) {
      // silencio intencional
    }
  }, [animationData]);

  useEffect(() => {
    if (animation.current) {
      try {
        animation.current.destroy();
        loadAnimationData();
      } catch (error) {
        // silencio intencional
      }
    } else {
      loadAnimationData();
    }

    return () => {
      try {
        animation.current.destroy();
      } catch (error) {
        // silencio intencional
      }
    };
  }, [animationData, loadAnimationData]);

  return <div ref={container} />;
}

export default LottieAnimation;
